<template lang="pug">
  .overview-view
      OverviewMap(
        v-if="loadedChartInfo"
        :sensors="[ ...sensors]"
        :fields="[ ...fields]"
        :dateRange="dateRange"
      )
</template>

<script>
import { filterUtils } from "@utils/filterUtils";
import Pagination from "@components/_shared/Pagination";
import FilterFieldDropdown from "@components/_shared/FilterFieldDropdown";
import OverviewMap from "@components/client/overview/OverviewMap";
import { mapActions, mapState } from "vuex";
import SearchWithButtons from "@components/_shared/SearchWithButtons";

export default {
  name: "OverviewView",
  mixins: [filterUtils],

  components: {
    Pagination,
    FilterFieldDropdown,
    OverviewMap,
    SearchWithButtons
  },

  data() {
    return {
      selectedFieldId: "",
      search: "",
      dateRange: [new Date(new Date().setHours(0,0,0,0)), new Date()],
      location: false,
      ridesInProgress: 0,
      sensors: [],
      fields: [],
      loadedChartInfo: true,
    }
  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("field", ["selectedField", "selectedFieldInfoSettings"]),

  },

  async created(){
    if(this.selectedField && this.selectedField != "all"){
      this.selectedFieldId = this.selectedField.id.toString();
      await this.handleGetMapSensors();
      await this.handleGetMapFields(this.selectedField.id);
    }      
    else {
      this.selectedFieldId = "all";
      await this.handleGetMapSensors();
      await this.handleGetMapFields("all");
    }
  },

  watch: {
    async selectedField(){
      if(this.selectedField && this.selectedField != "all"){
        this.selectedFieldId = this.selectedField.id.toString();
        await this.handleGetMapSensors();
        await this.handleGetMapFields(this.selectedField.id);
      }
      else {
        this.selectedFieldId = "all";
        await this.handleGetMapSensors();
        await this.handleGetMapFields("all");
      }
    },

    // async selectedFieldInfoSettings(){
    //   await this.handleGetMapSensors();
    // }
  },

  methods: {
    ...mapActions('map', ['getMapStatistics']),
    ...mapActions('soilSensor', ['getSoilSensors']),
    ...mapActions('field', ['getField', "getFields"]),

    async handleGetMapSensors() {
      let computedParams = '?page_size=1000';

      if (this.selectedField  && this.selectedField != "all") {
        computedParams += `&by_field_id=${this.selectedField.id}`;
      }
      const response = await this.getSoilSensors(computedParams);
      this.sensors = response.data;
    },

    async handleGetMapFields(data) {
      let computedParams = '?page_size=1000';

      if (data != "all") {
        const response = await this.getField(data);
        this.fields = [response.data];
      }
      else {
        const response = await this.getFields(computedParams);
        this.fields = response.data;
      }
      
    },
  },
};
</script>

